import React, { useEffect, useState, useCallback } from 'react';
import useObservable from '../Hooks/useObservable.Hook';
import { getUser } from '../../Widget/Services/User.service';
import {
  getRootFolderHelper,
  getUserHelper,
  memberAuthorizationHelper,
  navigateToPricingPlansAppHelper,
} from '../../Widget/Shared/memberAuthorizationHelper';
import { setToast } from '../../Widget/Services/Toast.service';
import { TOAST } from '../../Constants/Toast.Constants';
import { setOpenedModal } from '../../Widget/Services/Modals.service';
import { MODAL_TYPES } from '../../Constants/Modals.Constants';
import { useAppContext } from '../../Widget/Shared/AppContext';

const withMemberAuthorization = (
  WrappedComponent: React.ComponentType<any>,
) => {
  return (props: any) => {
    const { compId } = useAppContext();
    const [state, setState] = useState<any>({
      requestLoginLastValue: null,
      navigateToPricingPlansApp: null,
      user: null,
      rootFolder: null,
    });

    const [error2, user]: any = useObservable(getUser());
    const memberAuthorization = async ({
      args,
      callBack,
      isAccessModal,
    }: any) => {
      if (!user?.isLoggedIn || isAccessModal) {
        state.requestLoginLastValue && state.requestLoginLastValue();
      } else {
        callBack && callBack(...args);
      }
    };
    const navigateToPricingPlansApp = async () => {
      state.navigateToPricingPlansApp &&
        state.navigateToPricingPlansApp(state.rootFolder.pricingPlansIds);
    };

    const openPrivacyModal = async () => {
      if (user !== undefined && user?.privacyStatus === 'PRIVATE') {
        setOpenedModal(MODAL_TYPES.JOINCOMMUNITY, compId);
      }
    };

    const getRequestLoginFunction = useCallback(async () => {
      try {
        const tempResult = await memberAuthorizationHelper();
        const tempUser = await getUserHelper();
        const navigateToPricingPlansApp =
          await navigateToPricingPlansAppHelper();
        const rootFolder = await getRootFolderHelper(compId);
        setState((prev: any) => ({
          ...prev,
          user: tempUser,
          requestLoginLastValue: tempResult,
          navigateToPricingPlansApp,
          rootFolder,
        }));
      } catch (e) {
        setToast({
          skin: TOAST.error,
          content: 'member authorization error',
        });
        return e;
      }
    }, []);

    useEffect(() => {
      getRequestLoginFunction();
    }, []);

    return (
      <>
        {user !== undefined && state.requestLoginLastValue !== null ? (
          <WrappedComponent
            {...props}
            memberAuthorization={memberAuthorization}
            navigateToPricingPlansApp={navigateToPricingPlansApp}
            openPrivacyModal={openPrivacyModal}
          />
        ) : null}
      </>
    );
  };
};
export default withMemberAuthorization;
